import React from 'react'
import Erro from './images/erro.png'
export const ImagemErro = () => <img src={Erro} alt="erro" />
